import {invoke} from "@hybird/core/bridge/hybirdBridge";
import {BridgeMethod} from "@hybird/core/bridge/core";

export class FlutterConsole extends BridgeMethod {
  constructor() {
    super();
  }

  async consoleDiskSize(params = {}) {
    return invoke("consoleDiskSize", {params});
  }

  async consoleFile(params = {}) {
    return invoke("consoleFile", {params});
  }
}

export const flutterConsole = new FlutterConsole();